import axios from 'axios'
import { config, configMultipart, url } from '@/store'
import { formatDateForServer } from '@/utils/utils.js'

const getAll = (params) => {
  const expands = 'expand=avatar,profile,department,position,status'
  return axios.get(`${url}/users?&${params.searchFilter}&${params.filterData}&sort=-id&per-page=${params.currentTake}&page=${params.currentPage}&${expands}`, config)
}

const getCurrentUser = () => {
  const expands = 'expand=profile,avatar,roles,department,sub_departments,families,educations,documents,position,status,employment,schedule,leader,subordinates'
  return axios.get(`${url}/users/profile?${expands},`, config)
}

const getSingle = (userId) => {
  const expands = 'expand=profile,avatar,roles,department,sub_departments,families,educations,documents,position,status,employment,schedule,leader,subordinates'
  return axios.get(`${url}/users/${userId}?${expands},`, config)
}

const getSingleLeadersSub = (userId) => {
  const expands = 'expand=leader,subordinates'
  return axios.get(`${url}/users/${userId}?${expands},`, config)
}

const postUser = (postData) => {
  return axios.post(`${url}/users`, postData, config)
}

const putUser = (params) => {
  return axios.put(`${url}/users/${params.id}`, params.updateData, config)
}

const putProfile = (params) => {
  return axios.put(`${url}/profiles/${params.id}`, params.updateData, config)
}

const renewAuthTime = () => {
  const postData = {
    last_auth_at: formatDateForServer(new Date())
  }
  return axios.post(`${url}/auth-time`, postData, config)
}

const postAvatar = (params) => {
  return axios.post(`${url}/users/${params.userId}`, params.formData, configMultipart)
}

const deleteUser = (userId) => {
  return axios.delete(`${url}/users/${userId}`, config)
}

const postFamilies = (memberData) => {
  return axios.post(`${url}/families`, memberData, config)
}

const putFamilies = (params) => {
  return axios.put(`${url}/families/${params.memberId}`, params.memberData, config)
}

const deleteFamilies = (memberId) => {
  return axios.delete(`${url}/families/${memberId}`, config)
}

const postDocument = (postData) => {
  return axios.post(`${url}/documents`, postData, config)
}

const putDocument = (params) => {
  return axios.put(`${url}/documents/${params.id}`, params.updateData, config)
}

const deleteDocument = (documentId) => {
  return axios.delete(`${url}/documents/${documentId}`, config)
}

const postEducation = (postData) => {
  return axios.post(`${url}/education`, postData, config)
}

const putEducation = (params) => {
  console.log(params)
  return axios.put(`${url}/education/${params.id}`, params.updateData, config)
}

const deleteEducation = (educationId) => {
  return axios.delete(`${url}/education/${educationId}`, config)
}

export default {
  getAll,
  getCurrentUser,
  getSingle,
  getSingleLeadersSub,
  postUser,
  putUser,
  putProfile,
  renewAuthTime,
  postAvatar,
  deleteUser,
  postFamilies,
  putFamilies,
  deleteFamilies,
  postDocument,
  putDocument,
  deleteDocument,
  postEducation,
  putEducation,
  deleteEducation
}
